/* mo-life.js: the "How long do <brand> mattresses last" articles (sections/mo-life.liquid), Mattress Overstock,
   2026-10-15. Plain JS, no library.
   - Lifespan chart: the age slider moves the red marker (--age) through every row; each row says where that age
     sits against the article's range; the verdict line applies the article's own rule (age line, number of signs,
     the impression sign for a warranty claim). One orchestrated moment on first view: bars grow from their low year
     and the marker sweeps to the starting age (armed by the inline script after the chart; reduced motion skips it).
   - Signs checklist: read at runtime from the list under the article's own "signs" heading, so the body stays the
     single source of those words.
   - "Show it in the article": scrolls to the sentence behind a bar and highlights it for a moment.
   - Contents rail: gives the body's H2s ids (no change to the stored body) and marks the section in view.
   - Beds: the size picker reprices each card from its variant prices (Liquid gives cents).
   No DOM writes happen in response to DOM changes (assets/custom.js observes the body). */
(function () {
  'use strict';
  var root = document.querySelector('[data-mo-life]');
  if (!root) return;
  root.classList.add('is-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = root.querySelector('[data-ml-body]');

  function norm(s) {
    return (s || '').replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* ------------------------------------------------------------------ chart */
  var chart = root.querySelector('[data-ml-chart]');
  if (chart) initChart(chart);

  function initChart(chart) {
    var input = chart.querySelector('[data-ml-age]');
    var out = chart.querySelector('[data-ml-age-out]');
    var unit = chart.querySelector('[data-ml-age-unit]');
    var rows = [].slice.call(chart.querySelectorAll('.ml-row[data-lo]'));
    var verdictEl = chart.querySelector('[data-ml-verdict]');
    var signsBox = chart.querySelector('[data-ml-signs]');
    var signsList = chart.querySelector('[data-ml-signs-list]');
    var signsN = chart.querySelector('[data-ml-signs-n]');
    var ruleEls = {};
    [].forEach.call(chart.querySelectorAll('[data-ml-rule]'), function (p) { ruleEls[p.getAttribute('data-ml-rule')] = p; });
    var ra = +chart.getAttribute('data-rule-age') || 0;
    var rs = +chart.getAttribute('data-rule-signs') || 0;
    var cs = +chart.getAttribute('data-claim-sign') || 0;
    var rlabel = chart.getAttribute('data-rule-label') || '';
    var texts = { shop: chart.getAttribute('data-shop') || '', claim: chart.getAttribute('data-claim') || '', any: chart.getAttribute('data-any') || '' };
    var hasBeds = !!root.querySelector('[data-ml-beds]');
    var start = +chart.getAttribute('data-age') || 0;
    var age = start;
    var boxes = [];
    var lastHit = null;

    rows.forEach(function (r, i) {
      r._lo = +r.getAttribute('data-lo');
      r._hi = +r.getAttribute('data-hi');
      r._w = r.hasAttribute('data-warranty');
      r._st = r.querySelector('.ml-row__state');
      r._prev = r._st ? r._st.getAttribute('data-st') : '';
      r.style.setProperty('--i', i);
    });

    function stateOf(r, a) {
      if (r._w) return a > r._hi ? ['past', 'Past the term'] : ['in', 'Inside the term'];
      if (a > r._hi) return ['past', 'Past its range'];
      if (a >= r._lo) return ['in', 'Inside its range'];
      return ['pre', 'Not there yet'];
    }

    function paint(a, bump) {
      chart.style.setProperty('--age', a);
      rows.forEach(function (r) {
        var s = stateOf(r, a);
        if (r._st && r._st.getAttribute('data-st') !== s[0]) {
          r._st.setAttribute('data-st', s[0]);
          r._st.textContent = s[1];
          if (bump && !reduce && (s[0] === 'in' || s[0] === 'past') && !r._w) {
            r.classList.remove('is-bump'); void r.offsetWidth; r.classList.add('is-bump');
          }
        }
      });
    }

    function setAge(a, opts) {
      a = Math.max(0, Math.min(16, Math.round(a)));
      age = a;
      paint(a, !(opts && opts.quiet));
      if (out) out.textContent = a;
      if (unit) unit.textContent = a === 1 ? 'year' : 'years';
      if (input) {
        if (+input.value !== a) input.value = a;
        input.setAttribute('aria-valuetext', a + (a === 1 ? ' year' : ' years'));
      }
      verdict();
    }

    function verdict() {
      if (!verdictEl) return;
      var n = boxes.filter(function (b) { return b.checked; }).length;
      var claimOn = cs > 0 && boxes[cs - 1] && boxes[cs - 1].checked;
      var rel = '';
      if (ra) rel = age > ra ? ', past the article\'s ' + rlabel : age === ra ? ', exactly at the article\'s ' + rlabel : ', under the article\'s ' + rlabel;
      if (!ra) {
        var nr = 0, inr = 0, wIn = null;
        rows.forEach(function (r) {
          if (r._w) { wIn = age <= r._hi; return; }
          nr++; if (age >= r._lo && age <= r._hi) inr++;
        });
        rel = nr ? ', inside ' + inr + ' of the article\'s ' + nr + (nr === 1 ? ' range' : ' ranges') : (wIn === null ? '' : wIn ? ', inside the warranty term' : ', past the warranty term');
      }
      var base = 'At ' + age + (age === 1 ? ' year' : ' years') + rel + '.';
      var hit = null;
      if (ra && rs && n >= rs && age > ra && texts.shop) hit = 'shop';
      else if (ra && !rs && age >= ra && texts.shop) hit = 'shop';
      else if (claimOn && (!ra || age < ra) && texts.claim) hit = 'claim';
      else if (n > 0 && texts.any) hit = 'any';
      verdictEl.textContent = '';
      verdictEl.appendChild(document.createTextNode(base + ' '));
      if (hit) {
        var st = document.createElement('strong');
        st.textContent = texts[hit];
        verdictEl.appendChild(st);
        if (hit === 'shop' && rs && hasBeds) {
          verdictEl.appendChild(document.createTextNode(' '));
          var a = document.createElement('a');
          a.href = '#ml-beds';
          a.textContent = 'See the beds it links to';
          verdictEl.appendChild(a);
        }
      } else if (boxes.length) {
        verdictEl.appendChild(document.createTextNode(n === 0 ? (rs || cs ? 'Tick the signs you see to apply the article\'s rule.' : 'Tick the signs you see.') : n + ' of ' + boxes.length + ' signs ticked.'));
      }
      Object.keys(ruleEls).forEach(function (k) { ruleEls[k].classList.toggle('is-on', k === hit); });
      if (signsN && boxes.length) signsN.textContent = n + ' of ' + boxes.length;
      if (hit !== lastHit && hit && !reduce) {
        verdictEl.classList.remove('is-hit'); void verdictEl.offsetWidth; verdictEl.classList.add('is-hit');
      }
      lastHit = hit;
    }

    // the signs checklist, from the article's own list
    if (signsBox && signsList && body) {
      var match = norm(signsBox.getAttribute('data-match')).toLowerCase();
      var heads = [].slice.call(body.querySelectorAll('h2, h3'));
      var head = null;
      for (var i = 0; i < heads.length; i++) {
        if (match && norm(heads[i].textContent).toLowerCase().indexOf(match) > -1) { head = heads[i]; break; }
      }
      var list = null;
      for (var el = head && head.nextElementSibling; el && !/^H2$/.test(el.tagName); el = el.nextElementSibling) {
        if (el.tagName === 'UL' || el.tagName === 'OL') { list = el; break; }
      }
      if (list) {
        var frag = document.createDocumentFragment();
        [].forEach.call(list.children, function (li, k) {
          var t = norm(li.textContent);
          if (!t) return;
          var lab = document.createElement('label');
          lab.className = 'ml-sign';
          var inp = document.createElement('input');
          inp.type = 'checkbox';
          inp.className = 'ml-sign__in';
          inp.setAttribute('data-k', k);
          var box = document.createElement('span');
          box.className = 'ml-sign__box';
          box.setAttribute('aria-hidden', 'true');
          var tx = document.createElement('span');
          tx.textContent = t;
          lab.appendChild(inp); lab.appendChild(box); lab.appendChild(tx);
          var item = document.createElement('li');
          item.appendChild(lab);
          frag.appendChild(item);
          boxes.push(inp);
        });
        signsList.appendChild(frag);
        signsList.addEventListener('change', verdict);
      } else {
        signsBox.hidden = true;
      }
    }

    if (input) {
      input.addEventListener('input', function () { setAge(+input.value); });
      chart.querySelector('.ml-age__label') && chart.querySelector('.ml-age__label').addEventListener('click', function () { input.focus(); });
    }
    verdict();

    // first view: armed before first paint by the inline script; play once when the chart is seen
    var armed = chart.classList.contains('is-arm');
    function play() {
      if (chart._played) return;
      chart._played = true;
      if (reduce || !chart.classList.contains('is-arm')) { chart.classList.remove('is-arm'); setAge(start, { quiet: true }); return; }
      requestAnimationFrame(function () {
        chart.classList.add('is-play');
        chart.classList.remove('is-arm');
        var t0 = null, dur = 1300, delay = 380;
        function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, Math.max(0, (ts - t0 - delay) / dur));
          var e = 1 - Math.pow(1 - p, 3);
          var a = e * start;
          chart.style.setProperty('--age', a.toFixed(3));
          var whole = Math.floor(a + 1e-6);
          if (whole !== chart._w) { chart._w = whole; paint(whole, true); if (out) out.textContent = whole; }
          if (p < 1 && !chart._stop) requestAnimationFrame(step);
          else if (!chart._stop) setAge(start, { quiet: true });
        }
        requestAnimationFrame(step);
      });
    }
    if (input) {
      // a shopper who grabs the slider during the sweep takes over at once
      ['pointerdown', 'keydown'].forEach(function (ev) { input.addEventListener(ev, function () { chart._stop = true; chart.classList.remove('is-arm'); chart.classList.add('is-play'); }); });
    }
    if (armed && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); play(); } });
      }, { threshold: 0.25 });
      io.observe(chart);
    } else {
      play();
    }
  }

  /* ------------------------------------------------------------------ show a sentence in the article */
  function findIn(quote) {
    if (!body) return null;
    var q = norm(quote);
    var els = body.querySelectorAll('p, li, h3');
    for (var i = 0; i < els.length; i++) {
      if (norm(els[i].textContent).indexOf(q) > -1) return els[i];
    }
    return null;
  }

  function highlight(el, quote) {
    var q = norm(quote);
    if (window.CSS && CSS.highlights && window.Highlight) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue.replace(/[‘’]/g, "'").replace(/ /g, ' ');
        var k = t.indexOf(q);
        if (k > -1) {
          var r = new Range();
          r.setStart(n, k); r.setEnd(n, k + q.length);
          CSS.highlights.set('ml-quote', new Highlight(r));
          setTimeout(function () { CSS.highlights.delete('ml-quote'); }, 2600);
          return;
        }
      }
    }
    el.classList.add('ml-flash');
    setTimeout(function () { el.classList.add('is-out'); }, 1400);
    setTimeout(function () { el.classList.remove('ml-flash', 'is-out'); }, 2800);
  }

  root.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-ml-show]');
    if (!a) return;
    var quote = a.getAttribute('data-ml-show');
    var el = findIn(quote);
    if (!el) return;
    ev.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
    highlight(el, quote);
  });

  /* ------------------------------------------------------------------ contents rail */
  var toc = root.querySelector('[data-ml-toc]');
  if (toc && body) {
    var hs = [].slice.call(body.querySelectorAll('h2'));
    var links = [].slice.call(toc.querySelectorAll('[data-ml-toc-i]'));
    hs.forEach(function (h, i) { if (!h.id) h.id = 'ml-s-' + (i + 1); });
    links.forEach(function (a) {
      var h = hs[+a.getAttribute('data-ml-toc-i') - 1];
      if (h && h.id !== 'ml-s-' + a.getAttribute('data-ml-toc-i')) a.setAttribute('href', '#' + h.id);
    });
    var on = -1;
    function mark(i) {
      if (i === on) return;
      on = i;
      links.forEach(function (a, k) {
        var is = k === i;
        a.classList.toggle('is-on', is);
        if (is) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }
    var tick = false;
    function spy() {
      tick = false;
      var best = -1, line = window.innerHeight * 0.35;
      for (var i = 0; i < hs.length; i++) { if (hs[i].getBoundingClientRect().top < line) best = i; else break; }
      mark(best);
    }
    if (hs.length) {
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(spy); } }, { passive: true });
      window.addEventListener('hashchange', function () { requestAnimationFrame(spy); });
      spy();
    }
  }

  /* ------------------------------------------------------------------ beds: reprice by size */
  var sizeBox = root.querySelector('[data-ml-size]');
  if (sizeBox) {
    var live = root.querySelector('[data-ml-size-live]');
    var cards = [].slice.call(root.querySelectorAll('.ml-bed')).map(function (c) {
      var d = {};
      try { d = JSON.parse(c.querySelector('[data-ml-v]').textContent); } catch (e) {}
      return { el: c, v: d.v || {}, amt: c.querySelector('[data-ml-price]'), sz: c.querySelector('[data-ml-sz]') };
    });
    function money(cents) {
      var x = +cents / 100;
      if (!isFinite(x)) return '';
      var cents = Math.round(x * 100) % 100 !== 0;
      return '$' + x.toLocaleString('en-US', { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2 });
    }
    sizeBox.addEventListener('change', function (ev) {
      var size = ev.target && ev.target.value;
      if (!size) return;
      var short = size === 'California King' ? 'Cal King' : size;
      cards.forEach(function (c) {
        var v = c.v[size];
        if (v) {
          c.amt.textContent = money(v[0]);
          c.amt.classList.remove('is-none');
          c.sz.textContent = short;
        } else {
          c.amt.textContent = 'Not made in ' + short;
          c.amt.classList.add('is-none');
          c.sz.textContent = '';
        }
      });
      if (live) live.textContent = 'Prices shown for ' + short + '.';
    });
  }
})();

/* fit-fix 2026-10-16: the sticky title bar parks and sticks at the header's bottom (assets/mo-life.css reads
   --ml-nav-top). header.js writes --header-height only on scroll, so a header that grows after the last scroll (web
   fonts wrapping the menu onto a second row, a resize) left the bar inside it. Watch the header's own height instead.
   One custom property on the bar, written only when the height changes (custom.js watches childList, not styles). */
(function () {
  'use strict';
  var nav = document.querySelector('article-navigation.blog-post-detail--navigation');
  var hdr = document.querySelector('theme-header');
  if (!nav || !hdr || !window.ResizeObserver) return;
  var last = '';
  new ResizeObserver(function () {
    var v = hdr.clientHeight + 'px';
    if (v !== last) { last = v; nav.style.setProperty('--ml-nav-top', v); }
  }).observe(hdr, { box: 'border-box' });
})();
